import script from "./WebAIAgent.vue?vue&type=script&setup=true&lang=js"
export * from "./WebAIAgent.vue?vue&type=script&setup=true&lang=js"

import "./WebAIAgent.vue?vue&type=style&index=0&id=416c2d5e&scoped=true&lang=scss"
import "./WebAIAgent.vue?vue&type=style&index=1&id=416c2d5e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-416c2d5e"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QSpinnerBars from 'quasar/src/components/spinner/QSpinnerBars.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QBtn,QInput,QSeparator,QScrollArea,QSpinnerBars,QRadio,QTabPanels,QTabPanel,QDialog,QCard,QImg,QIcon,QCheckbox});
